var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 12,
    width: 12,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wpldytb6ra"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 519",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 19",
    style: {
      clipPath: "url(#wpldytb6ra)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11226"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11225"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5791",
    d: "M883.931 278.18v-2.456a.289.289 0 0 1 .072-.185q3.623-3.663 7.252-7.322c.036-.036.067-.079.089-.105l2.595 2.595c-.185.178-.39.368-.589.568q-3.388 3.417-6.779 6.834a.236.236 0 0 1-.149.072h-2.416c-.019.003-.042 0-.075-.001z",
    transform: "translate(-883.027 -265.089)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5792",
    d: "M892.464 270.571 889.89 268l.791-.791c.138-.137.273-.276.414-.411a.648.648 0 0 1 .955 0q.777.77 1.548 1.549a.625.625 0 0 1 .064.872c-.392.459-.8.904-1.198 1.352z",
    transform: "translate(-880.713 -265.681)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.a38d17f35185ec237fbf88e7f1ee44a3.svg";
export { ForwardRef as ReactComponent };